import { Box, Group, Paper, Text } from '@mantine/core';
import { Condition } from '@medplum/fhirtypes';
import { getDisplayString } from '@medplum/core';
import { StatusBadge } from '@/components/medplum-react/StatusBadge/StatusBadge';
import { LabeledField } from '@/components/LabeledField';
import { useTranslation } from 'react-i18next';

// -----------------------------------------------------------------------------
export interface HpoListItemProps {
  readonly hpoCondition: Condition;
}

// -----------------------------------------------------------------------------
export const HpoListItem = ({ hpoCondition }: HpoListItemProps) => {
  const { t } = useTranslation(['patient-pages']);

  const hpoName =
    hpoCondition.code?.coding?.[0]?.display ||
    hpoCondition.code?.text ||
    getDisplayString(hpoCondition);

  const hpoCode = hpoCondition.code?.coding?.[0]?.code;
  const clinicalStatus = hpoCondition.clinicalStatus;
  const clinicalStatusCode = clinicalStatus?.coding?.[0]?.code;
  const clinicalStatusDisplay = clinicalStatusCode
    ? t(`diagnosis.clinicalStatus.${clinicalStatusCode}`, {
        ns: 'patient-pages',
        defaultValue:
          clinicalStatus?.coding?.[0]?.display || clinicalStatusCode,
      })
    : clinicalStatus?.coding?.[0]?.display;
  const note = hpoCondition.note?.[0]?.text;

  return (
    <Paper p="sm" withBorder radius="md">
      <Group justify="space-between" wrap="nowrap" align="flex-start">
        <Box flex={1}>
          {/* HPO name */}
          <Text fw={600} size="sm" mb={4}>
            {hpoName}
          </Text>

          {/* HPO code */}
          {hpoCode && (
            <Text size="xs" c="dimmed" mb={8}>
              {hpoCode}
            </Text>
          )}

          {/* Description */}
          {note && (
            <LabeledField
              label={t('summaryPage.summary.hpoConditions.description', {
                ns: 'patient-pages',
                defaultValue: 'Description',
              })}
              value={note}
            />
          )}
        </Box>

        {clinicalStatusDisplay && (
          <StatusBadge
            status={clinicalStatusCode ?? ''}
            label={clinicalStatusDisplay}
            variant="light"
          />
        )}
      </Group>
    </Paper>
  );
};
